module.exports = __webpack_public_path__ + "images/9ef138932c9314ad8cb4ea7cac4059dc-Xcaret.png";